import { render, staticRenderFns } from "./liffListFilterItem.vue?vue&type=template&id=1b020748&"
import script from "./liffListFilterItem.vue?vue&type=script&lang=js&"
export * from "./liffListFilterItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports